import { render, staticRenderFns } from "./AllestimentiForm.vue?vue&type=template&id=2c7d1c16&scoped=true&"
import script from "./AllestimentiForm.vue?vue&type=script&lang=js&"
export * from "./AllestimentiForm.vue?vue&type=script&lang=js&"
import style0 from "./AllestimentiForm.vue?vue&type=style&index=0&id=2c7d1c16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d1c16",
  null
  
)

export default component.exports